export const sanitizeMercadoPagoResourceId = (value: string): string => value.replace(/[^A-Za-z0-9._:-]/g, "")
